import UrlUtils from '../../../../utils/url';
import ApiUtils from '../../../../utils/api';
import { Api } from '../../../../typings/api';

const urlRegExp = /url\((['"]?)(.+?)\1\)/g;

const getCssWithUpdatedUrls = (galleryConfig: Api.Config, css: string, resourceId: number): string => {
	// replace relative urls from inDesign css file to absolute urls
	return css.replace(urlRegExp, (match, quote, relPath) => {
		const url = UrlUtils.getEditorResourceUrl(galleryConfig, resourceId, relPath);
		return `url("${url}?token=${ApiUtils.token}&preventRedirect=true")`;
	});
};

const getExternalCssWithUpdatedUrls = (galleryConfig: Api.Config, css: string, resourceId: number, cssRelUrl: string): string => {
	// replace relative urls from inDesign css file to absolute urls
	return css.replace(urlRegExp, (match, quote, relPath) => {
		const correctedRelPath = relPath.replace('../', getPathFromCssRelUrl(cssRelUrl, resourceId));
		const url = UrlUtils.getEditorResourceUrl(galleryConfig, resourceId, correctedRelPath);
		return `url("${url}?token=${ApiUtils.token}&preventRedirect=true")`;
	});
};

const getPathFromCssRelUrl = (cssRelUrl: string, resourceId: number): string => {
	const regExp = new RegExp(`${resourceId}\\/(.*?)css\\/`);
	const match = cssRelUrl.match(regExp);

	return match ? match[1] : '';
};

const getCssWithUpdatedAnimations = (css: string): string => {
	return css
		// setting animation-duration to 0s doesn't play animation
		.replace(/(animation-duration:\s?)(\d+(\.\d+)?)/g, '$1' + '0.001')
		.replace(/(animation-delay:\s?)(\d+(\.\d+)?)/g, '$1' + '0.001')
		// play animations only once
		.replace(/(animation-iteration-count:\s?)(\d+(\.\d+)?|infinite)/g, '$1' + '1');
};

export const getParsedCss = (galleryConfig: Api.Config, css: string, resourceId: number, extCssRelUrl?: string): string => {
	let parsedCss = extCssRelUrl
		? getExternalCssWithUpdatedUrls(galleryConfig, css, resourceId, extCssRelUrl)
		: getCssWithUpdatedUrls(galleryConfig, css, resourceId);
	parsedCss = getCssWithUpdatedAnimations(parsedCss);

	return parsedCss;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/css.ts